<template>
  <div class="risk-bg">
    <div class="risk-left">
      <dv-border-box-11 title="风险等级动态分析" class="chart-box">
        <risk-leve-echarts
          v-if="riskLeveData.length > 0"
          :echartsData="riskLeveData"
        ></risk-leve-echarts>
        <div v-else class="noData">暂无数据</div>
      </dv-border-box-11>
      <dv-border-box-11 title="隐患类型动态分析" class="chart-box">
        <unsafe-type-echarts
          v-if="unsafeTypeData.length > 0"
          :echartsData="unsafeTypeData"
        ></unsafe-type-echarts>
        <div v-else class="noData">暂无数据</div>
      </dv-border-box-11>

      <dv-border-box-11 title="区域隐患统计" class="chart-box">
        <hidden-danger-statistic
          v-if="hiddenDangerData.length > 0"
          :echartsData="hiddenDangerData"
        >
        </hidden-danger-statistic>
        <div v-else class="noData">暂无数据</div>
      </dv-border-box-11>
    </div>
    <div class="risk-center">
      <div>
        <div class="risk-title">隐患排查治理</div>
        <div class="title-underline"></div>
        <dv-border-box-8 :reverse="true" class="dv-border-box">
          <div class="number-content">
            <div
              class="number-content-item"
              @click="hiddenClick(3, statisticsData['1'])"
            >
              <count-to-component
                style="color:#ff0000"
                :num="statisticsData['1']"
              ></count-to-component>
              <span> 重大隐患 </span>
            </div>
            <div class="item-separator"></div>
            <div
              class="number-content-item"
              @click="hiddenClick(1, statisticsData['2'])"
            >
              <count-to-component
                style="color:#ffff00"
                :num="statisticsData['2']"
              ></count-to-component>
              <span> 一般隐患 </span>
            </div>
            <div class="item-separator"></div>
            <div class="number-content-item">
              <count-to-component
                :num="statisticsData['0']"
              ></count-to-component>
              <span> 当前隐患总数 </span>
            </div>
          </div>
        </dv-border-box-8>
      </div>
      <div>
        <div class="title-underline" style="margin-top: 20px"></div>
        <div class="risk-title" style="margin-top: 8px">
          风险分级管控
        </div>
        <div class="title-underline"></div>
      </div>
      <div class="risk-ranke">
        <img src="@/assets/img/riskHiddenIcon/risk-hidden-bg-2.png" alt="" />

        <div
          class="risk-ranke-item"
          v-for="(item, index) in riskDataList"
          :key="index"
          @click="riskItemClick(riskTotalData[index])"
        >
          <div class="risk-hidden-halo">
            <div class="risk-hidden-halo-item"></div>
          </div>
          <div class="risk-ranke-item-box">
            <!-- 原点 -->
            <div></div>
            <span v-if="riskTotalData[index]">
              {{ riskTotalData[index].totalNum || 0 }}<br />{{ item }}
            </span>
          </div>
        </div>
      </div>
      <dv-border-box-11 title="风险比较四色图" class="four-color">
        <four-color-echarts
          v-if="fourColorData.length > 0"
          :echartsData="fourColorData"
        ></four-color-echarts>
        <div v-else class="noData">暂无数据</div>
      </dv-border-box-11>
    </div>
    <div class="risk-right">
      <div class="risk-right-content">
        <div class="patrol-task">
          <div class="table-List-bg">巡查率排名Top5</div>
          <patrol-task-num-chart
            v-if="patrolRankData.length > 0"
            :echartsData="patrolRankData"
          ></patrol-task-num-chart>
          <span v-else class="no-data">暂无数据</span>
        </div>
        <div class="front-patrol-task">
          <div class="task-title">
            <img
              class="left-img"
              src="@/assets/img/schoolBigData/security-left-img.png"
              alt=""
            />
            <span>巡查率排行榜</span>
            <img
              class="right-img"
              src="@/assets/img/schoolBigData/security-right-img.png"
              alt=""
            />
          </div>
          <div class="list-title">
            <div>排名</div>
            <div>巡查率</div>
            <div>风险点</div>
          </div>
          <div class="school-grade-list" v-if="sortPatrolRankData.length > 0">
            <div
              class="list-item"
              v-for="(item, index) in sortPatrolRankData"
              :key="index"
            >
              <div>NO.{{ index + 1 }}</div>
              <div>{{ item.inspectRiskPoint }}%</div>
              <el-tooltip
                class="item"
                effect="light"
                :content="item.nameRiskPoint"
                placement="top"
              >
                <div
                  style="text-overflow:ellipsis;white-space: nowrap; overflow:hidden;"
                >
                  {{ item.nameRiskPoint }}
                </div>
              </el-tooltip>
            </div>
          </div>
          <div v-else class="no-data">暂无数据</div>
        </div>
      </div>
    </div>
    <risk-dialog
      :show="riskListShow"
      @close="dialogClose"
      :searchParams="searchParams"
    ></risk-dialog>
    <hidden-dialog
      :show="hiddenListShow"
      @close="hiddenDialogClose"
      :searchParams="hiddenSearchParams"
    ></hidden-dialog>
  </div>
</template>
<script>
import riskLeveEcharts from "./components/riskLeveEcharts";
import unsafeTypeEcharts from "./components/unsafeTypeEcharts";
import hiddenDangerStatistic from "./components/hiddenDangerStatistic";
import patrolTaskNumChart from "./components/patrolTaskNumChart";
import fourColorEcharts from "@/components/fourColorEcharts";
import riskDialog from "./components/riskDialog";
import hiddenDialog from "./components/hiddenDialog";
import CountToComponent from "@/components/CountToComponent";
export default {
  name: "riskHiddenDanger",
  components: {
    riskLeveEcharts,
    unsafeTypeEcharts,
    hiddenDangerStatistic,
    patrolTaskNumChart,
    fourColorEcharts,
    riskDialog,
    hiddenDialog,
    CountToComponent
  },
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      riskLeveData: [], //风险类型动态分析
      unsafeTypeData: [], //隐患类型动态分析
      hiddenDangerData: [], //区域隐患统计
      statisticsData: {}, // 隐患排查治理条数统计
      patrolRankData: [], //风险点巡查率
      sortPatrolRankData: [],
      fourColorData: [], //风险比较四色图
      riskTotalData: [], //风险分级管控条数统计
      riskDataList: [
        "风险点总数",
        "低风险",
        "一般风险",
        "较大风险",
        "重大风险"
      ],
      riskListShow: false,
      searchParams: {
        eduId: "",
        regionCode: "",
        eduBuresuType: "",
        riskLevel: 0,
        schoolId: ""
      },
      hiddenListShow: false,
      hiddenSearchParams: {
        schoolId: "",
        hiddenDangerClass: ""
      }
    };
  },
  created() {
    this.getDynamicAnalysisRiskTypes();
    this.getHazardTypeAnalysis();
    this.getRegionalHiddenDanger();
    this.getHiddenDangerStatistics();
    this.getPatrolRankingStatistics();
    this.getFourColorsPictureData();
    this.getRiskTotal();
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    async getDynamicAnalysisRiskTypes() {
      let req = {
        schoolId: parseInt(this.userInfo.schoolId)
      };
      let res = await this.$Http.getDynamicAnalysisRiskTypes(req, true);
      if (res.code == 200) {
        let data = res.data || [];
        let nameList = ["低风险", "一般风险", "较大风险", "重大风险"];
        this.riskLeveData = data.map((element) => {
          element.name = nameList[element.riskLevelType];
          return element;
        });
      } else {
        this.riskLeveData = [];
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage || "风险类型动态分析获取失败"
        });
      }
    },
    async getHazardTypeAnalysis() {
      let req = {
        schoolId: parseInt(this.userInfo.schoolId)
      };
      let res = await this.$Http.getHazardTypeAnalysis(req, true);
      if (res.code == 200) {
        this.unsafeTypeData = res.data || [];
      } else {
        this.this.unsafeTypeData = [];
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage || "隐患类型动态分析获取失败"
        });
      }
    },
    // 区域隐患统计
    async getRegionalHiddenDanger() {
      let req = {
        schoolId: parseInt(this.userInfo.schoolId)
      };
      let res = await this.$Http.getRegionalHiddenDanger(req, true);
      if (res.code == 200) {
        this.hiddenDangerData = res.data || [];
      } else {
        this.hiddenDangerData = [];
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage || "区域隐患统计获取失败"
        });
      }
    },

    // 隐患排查治理条数统计
    async getHiddenDangerStatistics() {
      let req = {
        schoolId: parseInt(this.userInfo.schoolId)
      };
      let res = await this.$Http.getHiddenDangerStatistics(req, true);
      if (res.code == 200) {
        this.statisticsData = res.data || {};
      } else {
        this.statisticsData = {};
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage || "隐患排查治理信息获取失败"
        });
      }
    },
    // 巡查率排名Top5
    async getPatrolRankingStatistics() {
      let req = {
        schoolId: parseInt(this.userInfo.schoolId)
      };
      let res = await this.$Http.getPatrolRankingStatistics(req, true);
      if (res.code == 200) {
        let data = res.data || [];
        this.patrolRankData = data;
        this.sortPatrolRankData = data.sort(function(a, b) {
          return b.inspectRiskPoint - a.inspectRiskPoint;
        });
      } else if (res.code == 101) {
        this.patrolRankData = [];
        this.sortPatrolRankData = [];
      } else {
        this.patrolRankData = [];
        this.sortPatrolRankData = [];
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage || "风险点巡查率信息获取失败"
        });
      }
    },
    // 风险比较四色图
    async getFourColorsPictureData() {
      let req = {
        schoolId: parseInt(this.userInfo.schoolId)
      };
      let res = await this.$Http.fourColorsPictureData(req, true);
      if (res.code == 200) {
        let data = res.data || [];
        this.fourColorData = data;
      } else {
        this.fourColorData = [];
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage || "风险比较四色图信息获取失败"
        });
      }
    },
    // 风险分级管控条数统计
    async getRiskTotal() {
      let req = {
        schoolId: parseInt(this.userInfo.schoolId)
      };
      let res = await this.$Http.getSituationRiskTotalStatistics(req, true);
      if (res.code == 200) {
        let data = res.data || [];
        this.riskTotalData = data;
      } else {
        this.riskTotalData = [];
        this.$message({
          showClose: true,
          type: "error",
          message: res.messsage || "风险比较四色图信息获取失败"
        });
      }
    },
    riskItemClick(val) {
      if (val.totalNum == 0) {
        this.$message({
          showClose: true,
          message: "当前风险类型无数据，请查看其他风险类型！"
        });
      } else {
        if (val.totalType != -1) {
          // 暂不显示风险总数
          this.searchParams.riskLevel = val.totalType;
          this.searchParams.schoolId = this.userInfo.schoolId;
          this.riskListShow = true;
        }
      }
    },
    dialogClose() {
      this.riskListShow = false;
    },
    hiddenClick(leve, num) {
      if (num == 0) {
        this.$message({
          showClose: true,
          message: "当前隐患类型无数据，请查看其他隐患类型！"
        });
      } else {
        this.hiddenSearchParams.schoolId = this.userInfo.schoolId;
        this.hiddenSearchParams.hiddenDangerClass = leve;
        this.hiddenListShow = true;
      }
    },
    hiddenDialogClose() {
      this.hiddenListShow = false;
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.risk-bg {
  display: flex;
  justify-content: center;
  flex-direction: row;
  .risk-left {
    margin: 33px 0px 0px 34px;
    width: 450px;
    height: 800px;
    .chart-box {
      margin-top: 10px;
      width: 450px;
      height: 250px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .risk-center {
    margin: 33px 0px 10px 0px;
    width: calc(100% - 1000px);
    height: 800px;
    min-width: 890px;
    display: flex;
    // justify-content: center;
    flex-direction: column;
    .risk-title {
      margin-top: 10px;
      font-size: 18px;
      width: 100%;
      height: 30px;
      text-align: center;
      color: #c4cdff;
    }
    .title-underline {
      margin-top: 2px;
      width: 176px;
      margin-left: calc(50% - 88px);
      height: 1px;
      background-image: linear-gradient(
        to left,
        rgba(101, 207, 255, 0),
        rgba(101, 207, 255, 0.4),
        rgba(101, 207, 255, 0)
      );
    }
    .dv-border-box {
      margin-top: 10px;
      margin-left: calc(50% - 255px);
      width: 510px;
      height: 66px;
      .number-content {
        width: 100%;
        height: 100%;
        // background: url("~@/assets/img/schoolBigData/risk-title-content-bg.png") center center no-repeat;
        // background-size: 100% 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        .number-content-item {
          &:nth-child(5) {
            width: 33.25%;
            height: 66px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            span {
              &:nth-child(1) {
                font-size: 20px;
                color: #dbe1ff;
              }
              &:nth-child(2) {
                margin-top: 3px;
                font-size: 12px;
                color: #dbe1ff;
              }
            }
          }
          &:nth-child(1) {
            width: 33.25%;
            height: 66px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            span {
              &:nth-child(1) {
                font-size: 20px;
                color: #ff0000;
              }
              &:nth-child(2) {
                margin-top: 3px;
                font-size: 12px;
                color: #dbe1ff;
              }
            }
          }
          &:nth-child(3) {
            width: 33.25%;
            height: 66px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            span {
              &:nth-child(1) {
                font-size: 20px;
                color: #ffff00;
              }
              &:nth-child(2) {
                margin-top: 3px;
                font-size: 12px;
                color: #dbe1ff;
              }
            }
          }
        }
        .item-separator {
          width: 2px;
          height: 29px;
          background-color: #2a348d;
        }
      }
    }
    .risk-ranke {
      height: 310px;
      width: 640px;
      position: relative;
      margin-top: 20px;
      margin-left: calc(50% - 340px);
      background: url("~@/assets/img/riskHiddenIcon/risk_hidden-bg.gif");
      background-size: 100% 100%;
      img {
        margin-left: 67px;
        margin-top: 72px;
        height: 222px;
        width: 546px;
        opacity: 0.5;
      }
      .risk-ranke-item {
        transform: scale(1);
        transition: transform 0.8s;
        .risk-hidden-halo-item {
          opacity: 0;
          transition: all 1.2s;
        }
        &:nth-child(2) {
          &:hover {
            transform: scale(1);
          }
        }
        &:hover {
          transform: scale(1.05);
        }

        &:nth-child(2) {
          //风险总数
          position: absolute;
          left: 240px;
          top: 10px;
          width: 180px;
          height: 210px;
          cursor: pointer;

          .risk-ranke-item-box {
            width: 100%;
            height: 100%;
            background: url("~@/assets/img/riskHiddenIcon/risk-hidden-1-1.png");
            background-size: 100% 100%;
            position: relative;
            span {
              position: absolute;
              left: 68px;
              top: 4px;
              text-align: center;
              font-size: 12px;
              color: #ffff00;
            }
          }
          .risk-hidden-halo {
            position: relative;
            top: 110px;
            left: 20px;
            .risk-hidden-halo-item {
              position: absolute;
              top: 50px;
              left: 0px;
              width: 150px;
              height: 50px;
              background: url("~@/assets/img/riskHiddenIcon/risk-hidden-halo.png");
              background-size: 100% 100%;
              animation: bigger 5s infinite;
            }
          }
        }
        &:nth-child(3) {
          //低风险
          display: block;
          position: absolute;
          top: 200px;
          left: 440px;
          width: 149px;
          height: 101px;
          cursor: pointer;
          text-align: center;
          z-index: 1;
          .risk-ranke-item-box {
            width: 100%;
            height: 100%;
            background: url("~@/assets/img/riskHiddenIcon/risk_hidden-1.png");
            background-size: 100% 100%;
            position: relative;
            div {
              position: absolute;
              left: 20px;
              top: -20px;
              width: 15px;
              height: 15px;
              border-radius: 7.5px;
              background-color: #00b6ff;
            }
            span {
              position: absolute;
              left: 60px;
              top: -40px;
              text-align: center;
              font-size: 14px;
              color: #c4cdff;
            }
          }
          .risk-hidden-halo {
            position: relative;
            .risk-hidden-halo-item {
              position: absolute;
              top: 54px;
              left: 24px;
              width: 100px;
              height: 35px;
              background: url("~@/assets/img/riskHiddenIcon/risk-hidden-halo.png");
              background-size: 100% 100%;
              animation: bigger1 5s infinite;
            }
          }
        }
        &:nth-child(4) {
          //一般风险
          position: absolute;
          top: 65px;
          left: 500px;
          width: 107px;
          height: 71px;
          cursor: pointer;
          .risk-ranke-item-box {
            width: 100%;
            height: 100%;
            background: url("~@/assets/img/riskHiddenIcon/risk_hidden-2.png");
            background-size: 100% 100%;
            position: relative;
            div {
              position: absolute;
              left: -15px;
              top: -20px;
              width: 15px;
              height: 15px;
              border-radius: 7.5px;
              background-color: #ffff00;
            }
            span {
              position: absolute;
              left: 25px;
              top: -40px;
              text-align: center;
              font-size: 14px;
              color: #c4cdff;
            }
          }
          .risk-hidden-halo {
            position: relative;
            .risk-hidden-halo-item {
              position: absolute;
              top: 30px;
              left: 4px;
              width: 100px;
              height: 35px;
              background: url("~@/assets/img/riskHiddenIcon/risk-hidden-halo.png");
              background-size: 100% 100%;
              animation: bigger2 5s infinite;
            }
          }
        }
        &:nth-child(5) {
          //较大风险
          position: absolute;
          top: 30px;
          left: 110px;
          width: 134px;
          height: 88px;
          cursor: pointer;
          .risk-ranke-item-box {
            width: 100%;
            height: 100%;
            background: url("~@/assets/img/riskHiddenIcon/risk_hidden-3.png");
            background-size: 100% 100%;
            position: relative;
            div {
              position: absolute;
              left: 0px;
              top: -20px;
              width: 15px;
              height: 15px;
              border-radius: 7.5px;
              background-color: #ff6100;
            }
            span {
              position: absolute;
              left: 40px;
              top: -40px;
              text-align: center;
              font-size: 14px;
              color: #c4cdff;
            }
          }
          .risk-hidden-halo {
            position: relative;
            .risk-hidden-halo-item {
              position: absolute;
              top: 42px;
              left: 16px;
              width: 100px;
              height: 35px;
              background: url("~@/assets/img/riskHiddenIcon/risk-hidden-halo.png");
              background-size: 100% 100%;
              animation: bigger3 5s infinite;
            }
          }
        }
        &:nth-child(6) {
          //重大风险
          display: block;
          position: absolute;
          top: 210px;
          left: 50px;
          width: 169px;
          height: 101px;
          cursor: pointer;
          .risk-ranke-item-box {
            width: 100%;
            height: 100%;
            background: url("~@/assets/img/riskHiddenIcon/risk_hidden-4.png");
            background-size: 100% 100%;
            position: relative;
            div {
              position: absolute;
              left: 15px;
              top: -20px;
              width: 15px;
              height: 15px;
              border-radius: 7.5px;
              background-color: #ff0000;
            }
            span {
              position: absolute;
              left: 55px;
              top: -40px;
              text-align: center;
              font-size: 14px;
              color: #c4cdff;
            }
          }
          .risk-hidden-halo {
            position: relative;
            .risk-hidden-halo-item {
              position: absolute;
              top: 40px;
              left: 12px;
              width: 140px;
              height: 50px;
              background: url("~@/assets/img/riskHiddenIcon/risk-hidden-halo.png");
              background-size: 100% 100%;
              animation: bigger4 5s infinite;
            }
          }
        }
      }
    }
    .four-color {
      margin-left: calc(50% - 320px);
      margin-top: 15px;
      width: 640px;
      height: 250px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
  .risk-right {
    margin: 43px 34px 0px 0px;
    width: 420px;
    height: 770px;
    perspective: 200;
    -webkit-perspective: 200;
    .risk-right-content {
      padding-top: 8px;
      width: 100%;
      height: 100%;
      background: url("~@/assets/img/schoolBigData/basic-info-right-bg.png");
      background-size: 100% 100%;
      transition: all 1s;
      -webkit-transform-origin: right center;
      transform: rotateY(-2deg);
      &:hover {
        transform: rotateY(0deg);
      }
      .patrol-task {
        margin: 0px 15px 0px 5px;
        margin-top: 28px;
        width: 390px;
        height: 300px;
        display: flex;
        flex-direction: column;
        .no-data {
          height: 300px;
          display: flex;
          justify-content: center; /* 水平居中 */
          align-items: center; /* 垂直居中 */
          font-size: 16px;
          color: #b3bef4;
        }
      }
      .front-patrol-task {
        margin-top: 10px;
        width: 380px;
        height: 400px;
        margin: 20px;
        display: flex;
        flex-direction: column;
        .task-title {
          display: flex;
          justify-content: center;
          align-items: center;
          .left-img {
            margin-right: 10px;
            width: 80px;
            height: 12px;
            opacity: 0.5;
          }
          span {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #c4cdff;
            line-height: 25px;
          }
          .right-img {
            margin-left: 10px;
            width: 80px;
            height: 12px;
            opacity: 0.5;
          }
        }
        .list-title {
          width: 100%;
          margin-top: 16px;
          height: 38px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          div {
            flex: 0 0 30%;
            color: #dbe1ff;
            font-size: 18px;
            text-align: center;
          }
        }
        .school-grade-list {
          height: 350px;
          overflow-y: scroll;
          scrollbar-width: none;
          .list-item {
            display: flex;
            justify-content: space-around;
            align-items: center;
            margin: 8px 0 0px 0;
            cursor: pointer;
            height: 38px;
            background: rgba(17, 165, 215, 0.04);
            color: #dbe1ff;
            font-size: 16px;
            &:nth-child(2n) {
              background: rgba(17, 165, 215, 0.14);
            }
            div {
              flex: 0 0 33%;
              text-align: center;
            }
          }
        }
        .no-data {
          height: 350px;
          display: flex;
          justify-content: center; /* 水平居中 */
          align-items: center; /* 垂直居中 */
          font-size: 16px;
          color: #b3bef4;
        }
      }
    }
  }
}
@keyframes bigger {
  5% {
    opacity: 0;
    transform: scale(0.1);
  }
  8% {
    opacity: 0.5;
    transform: scale(0.5);
  }
  11% {
    opacity: 1;
    transform: scale(1);
  }
  12% {
    opacity: 0.8;
    transform: scale(1.1);
  }
  30% {
    opacity: 0;
    transform: scale(2);
  }
  100% {
    opacity: 0;
    transform: scale(2);
  }
}
@keyframes bigger1 {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  70% {
    opacity: 0;
    transform: scale(0.1);
  }
  85% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(2.5);
  }
}
@keyframes bigger2 {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  65% {
    opacity: 0;
    transform: scale(0.1);
  }
  70% {
    opacity: 1;
    transform: scale(1);
  }
  90% {
    opacity: 0;
    transform: scale(2.5);
  }
  100% {
    opacity: 0;
    transform: scale(0);
  }
}
@keyframes bigger3 {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  35% {
    opacity: 0;
    transform: scale(0.1);
  }
  45% {
    opacity: 1;
    transform: scale(1);
  }
  60% {
    opacity: 0;
    transform: scale(2.5);
  }
  100% {
    opacity: 0;
    transform: scale(0);
  }
}
@keyframes bigger4 {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  10% {
    opacity: 0;
    transform: scale(0.1);
  }
  15% {
    opacity: 1;
    transform: scale(1);
  }
  30% {
    opacity: 0;
    transform: scale(2);
  }
  100% {
    opacity: 0;
    transform: scale(0);
  }
}
.table-List-bg {
  align-items: center;
  height: 36px;
  text-align: center;
  color: #c4f0ff;
  line-height: 36px;
  font-size: 18px;
  background-image: linear-gradient(
    to left,
    rgba(143, 149, 255, 0),
    rgba(63, 120, 188, 1),
    rgba(143, 149, 255, 0)
  );
  border-radius: 4px;
  margin-top: 10px;
  margin-left: 10px;
  width: 212px;
}
.noData {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 250px;
  width: 100%;
  overflow: hidden;
  color: rgba(233, 237, 255, 0.8);
}
</style>
